export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['My records'],
      },
      {
        _name: 'CSidebarNavItem',
        name: 'My receipts',
        to: '/employee/receiptList',
        icon: 'cibSuperuser'
      },

    ]
  }
]